"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationsType = void 0;
var IntegrationsType;
(function (IntegrationsType) {
    IntegrationsType[IntegrationsType["TYPE_GOOGLE_ANALYTICS"] = 1] = "TYPE_GOOGLE_ANALYTICS";
    IntegrationsType[IntegrationsType["TYPE_FACEBOOK_PIXEL"] = 2] = "TYPE_FACEBOOK_PIXEL";
    IntegrationsType[IntegrationsType["TYPE_HOTJAR"] = 3] = "TYPE_HOTJAR";
    IntegrationsType[IntegrationsType["TYPE_ZENDESK_CHAT"] = 4] = "TYPE_ZENDESK_CHAT";
    IntegrationsType[IntegrationsType["TYPE_KLAVIYO"] = 5] = "TYPE_KLAVIYO";
    IntegrationsType[IntegrationsType["TYPE_STRIPE_AFFIRM"] = 6] = "TYPE_STRIPE_AFFIRM";
    IntegrationsType[IntegrationsType["TYPE_PAYPAL"] = 7] = "TYPE_PAYPAL";
    IntegrationsType[IntegrationsType["TYPE_CDN_DOMAIN"] = 8] = "TYPE_CDN_DOMAIN";
    IntegrationsType[IntegrationsType["TYPE_CUSTOM_SCRIPTS"] = 9] = "TYPE_CUSTOM_SCRIPTS";
    IntegrationsType[IntegrationsType["TYPE_OPERATE_STATISTICS"] = 35] = "TYPE_OPERATE_STATISTICS";
    IntegrationsType[IntegrationsType["TYPE_IMPACT"] = 60] = "TYPE_IMPACT";
    IntegrationsType[IntegrationsType["TYPE_GTM"] = 62] = "TYPE_GTM";
    IntegrationsType[IntegrationsType["TYPE_FIREBASE"] = 63] = "TYPE_FIREBASE";
    IntegrationsType[IntegrationsType["TYPE_PAY_TOMORROW"] = 29] = "TYPE_PAY_TOMORROW";
    IntegrationsType[IntegrationsType["TYPE_GOOGLE_ADDRESS_VALIDATION"] = 64] = "TYPE_GOOGLE_ADDRESS_VALIDATION";
})(IntegrationsType || (exports.IntegrationsType = IntegrationsType = {}));
